export const hostname = (config, data, globalConfig) => {
  return {
    hostname: globalConfig.hostname
  };
};